import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGenerateVendorSourceUserTokenDTO from "../../../models/DTO/IGenerateVendorSourceUserTokenDTO";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import Typeahead from "../../shared/Typeahead/Typeahead";
import IGetVendorSourcesDTO from "../../../models/DTO/IGetVendorSourcesDTO";
import IOnGetVendorSourcesDTO from "../../../models/DTO/IOnGetVendorSourcesDTO";
import IVendor_Source from "../../../models/IVendor_Source";
import EndpointsEnum from "../../../models/EndpointsEnum";
import OwTitle from "../../shared/OwTitle/OwTitle";
import TitleTagEnum from "../../../models/TitleTagEnum";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refresh?: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
};

export const VendorSourcesUsersSidebar: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [foundVendorSources, setFoundVendorSources] = useState<IVendor_Source[]>([]);
    const [selectedVendorSource, setSelectedVendorSource] = useState<IVendor_Source>();
    const [clearTypeahead, setClearTypeahead] = useState(false);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.TokenOnGenerateVendorSourceUserToken, onCreateToken);
        props.socket.on(EndpointsEnum.PurchaseOrderOnGetVendorSources, onGetVendorSourcesByName);

        return () => {
            props.socket.removeListener(EndpointsEnum.TokenOnGenerateVendorSourceUserToken, onCreateToken);
            props.socket.removeListener(EndpointsEnum.PurchaseOrderOnGetVendorSources, onGetVendorSourcesByName);
        };
    });

    const closeSidebar = () => {
        props.cancelFn();
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.value;

        switch (name) {
            case "email":
                setEmail(value);
                break;
        }
    };

    const saveUser = () => {
        if (email && selectedVendorSource) {
            const payload: IGenerateVendorSourceUserTokenDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorSourceGuid: selectedVendorSource.guid,
                recipient: email,
                sendEmail: true,
            };

            props.socket.emit(EndpointsEnum.TokenGenerateVendorSourceUserToken, payload);

            setIsActive(true);
        }
    };

    const onCreateToken = () => {
        setIsActive(false);
        props.cancelFn(true);
    };

    const getVendorSourcesByName = (name: string) => {
        const payload: IGetVendorSourcesDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            queryString: `?name=${name}`,
        };

        props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSources, payload);
    };

    const onGetVendorSourcesByName = (data: IOnGetVendorSourcesDTO) => {
        setFoundVendorSources(data.vendorSources);
    };

    const selectVendorSource = (vendorSource: IVendor_Source) => {
        setSelectedVendorSource(vendorSource);
    };

    const clearTypeaheadFn = () => {
        setSelectedVendorSource(undefined);
        setClearTypeahead(false);
    };

    return (
        <div className={"VendorSourcesUsersSidebar p-3"}>
            <div className={"d-flex justify-content-between"}>
                <OwTitle title={"send_invite"} tag={TitleTagEnum.H3} leftIconName={"fad fa-envelope"} />
                <div>
                    <OwButton centerIconClass={"fas fa-times"} className={"btn-danger"} fn={closeSidebar} />
                </div>
            </div>
            <div>
                <div className={"mt-4"}>
                    <OwLabel title={"vendor_source"} />
                    <div>
                        <Typeahead
                            isSelectableFn={() => true}
                            typeaheadApiFn={getVendorSourcesByName}
                            titleProp={"name"}
                            selectedItemFn={selectVendorSource}
                            typeaheadItems={foundVendorSources}
                            selectedItem={selectedVendorSource}
                            clearTypeahead={clearTypeahead}
                            clearTypeaheadCallback={clearTypeaheadFn}
                        />
                    </div>
                </div>

                <div className={"mt-4"}>
                    <OwLabel title={"email"} />
                    <div>
                        <OwFnInput fn={handleChange} name={"email"} value={email} />
                    </div>
                </div>

                <div className={"mt-4"}>
                    <OwButton title={"save"} fn={saveUser} active={isActive} disableOnActive={true} />
                </div>
            </div>
        </div>
    );
};
